// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'user_nickname',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'shop',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'order_detail',
    label: '',
    Object: 'value',
    width: '430'
  }, {
    prop: 'delivery_detail',
    label: '',
    Object: 'value',
    width: '430'
  }, {
    prop: 'status',
    back: true,
    label: '',
    Object: 'value',
    width: '120'
  }],
  orderViewItem: [{
    prop: 'status',
    back: true
  }, {
    prop: 'type'
  }, {
    prop: 'delivery_order'
  }, {
    prop: 'created_at',
    date: true,
    format: ['YYYY年mm月dd日 HH:MM', 'YYYY-mm-dd HH:MM']
  }, {
    prop: 'invoice_number'
  }, {
    prop: 'shop'
  }, {
    prop: 'payment_channel'
  }, {
    prop: 'bill'
  }, {
    prop: 'paid_at',
    date: true,
    format: ['YYYY年mm月dd日 HH:MM', 'YYYY-mm-dd HH:MM']
  }, {
    prop: 'remarks'
  }, {
    prop: 'admin_remarks'
  }],
  CustomerViewItem: [{
    prop: 'user_name'
  }, {
    prop: 'contact_number'
  }, {
    prop: 'customer_id'
  }, {
    prop: 'email'
  }],
  deliveryViewItem: [{
    prop: 'delivery_time'
  }, {
    prop: 'receiver_name'
  }, {
    prop: 'detail_address'
  }, {
    prop: 'receiver_phone_number'
  }],
  collectionViewItem: [{
    prop: 'collection_time'
  }, {
    prop: 'receiver_name'
  }, {
    prop: 'detail_address'
  }, {
    prop: 'receiver_phone_number'
  }],
  afterSaleViewItem: [{
    prop: 'id',
    Object: 'value'
  }, {
    prop: 'order_type',
    Object: 'value'
  }],
  tableDataViewItem: [{
    prop: 'image',
    img: true,
    label: '',
    width: '50'
  }, {
    prop: 'shop_item',
    label: '',
    Object: 'value'
    // width: '100'
  }, {
    prop: 'shop_item_stock',
    label: '',
    Object: 'value'
    // width: '100'
  }, {
    prop: 'preferences',
    label: '',
    Object: 'value'
    // width: '40'
  }, {
    prop: 'sku',
    label: '',
    Object: 'value'
    // width: '40'
  }, {
    prop: 'count',
    label: '',
    // width: '40',
    Object: 'value'
  }, {
    prop: 'price',
    label: '',
    Object: 'value'
    // width: '40'
  }, {
    prop: 'status',
    back: true,
    label: '',
    Object: 'value',
    width: '40'
  }],
  host_information: [{
    prop: 'host_name'
  }, {
    prop: 'phone_number'
  }, {
    prop: 'host_id'
  }],
  exchange_information: [{
    prop: 'after_sales_order_id'
  }, {
    prop: 'parent_shop_payment_id'
  }]
}
